import { addPrintJob } from '../lib/supabase/api/add-print-job';
import useDocumentGroupsStore from '../store/documentGroupsStore';
import usePrintStore from '../store/printStore';
import { useAuthStore } from '../store/authStore';

/**
 * Interface for the result of uploading print jobs
 */
interface UploadPrintJobsResult {
  success: boolean;
  totalUploaded: number;
  failedUploads: Array<{
    groupId: string;
    error: string;
  }>;
  successfulUploads: Array<{
    groupId: string;
    settingsCode: number;
  }>;
}

/**
 * Uploads all document groups as print jobs to the database
 * Each document group becomes a separate print job
 */
export async function uploadPrintJobs(totalPrice: number, emailInvoicePath?: string, combinedFilePath?: string, updatedFiles: Array<{emailInvoicePath: string; combined_file?: string; groupId?: string}> = []): Promise<UploadPrintJobsResult> {
  // Get document groups from the store
  const documentGroups = useDocumentGroupsStore.getState().documentGroups;
  
  // Get selected shop from the print store
  const selectedShop = usePrintStore.getState().selectedShop;
  
  // If no shop is selected, we can't proceed
  if (!selectedShop) {
    throw new Error('No shop selected for print job');
  }
  
  // Check if the user is a special user (admin or teacher)
  const isSpecialUser = useAuthStore.getState().isSpecialUser();
  
  const result: UploadPrintJobsResult = {
    success: true,
    totalUploaded: 0,
    failedUploads: [],
    successfulUploads: []
  };
  
  const email_invoice_path = emailInvoicePath || (updatedFiles[0]?.emailInvoicePath) || '';
  // Upload each document group as a print job
  let i = 0;
  for (const group of documentGroups) {
    try {
      // Make sure the group has an upload URL
      if (!group.uploadFilePath) {
        throw new Error(`Document group ${group.id} has no upload URL`);
      }
      
      // Get the first document in the group for the file name
      const firstDoc = group.documents[0];
      const fileName = firstDoc ? firstDoc.name : 'document.pdf';
      
      // Get the total pages and price from the group directly
      const totalPages = group.totalPages || 0;
      
      // For special users, amount is 0 (they don't pay)
      // But shop still gets their earning from the platform
      const jobAmount = isSpecialUser ? 0 : (group.price || 0);
      const shopAmount = group.shopEarning || 0; // Shop always gets their earning

      const copies = group.printSettings.copies || 1;
      const pages = totalPages/copies;
      
      console.log(`
🚨🚨🚨 WEBAPP SENDING JOB TO PAYMENT SERVER 🚨🚨🚨`);
      console.log(`Group ID: ${group.id}`);
      console.log(`File Name: ${fileName}`);
      console.log(`Total Pages: ${totalPages}`);
      console.log(`Copies: ${copies}`);
      console.log(`Pages per copy: ${pages}`);
      console.log(`User Amount: ${jobAmount}`);
      console.log(`🔥🔥🔥 SHOP_AMT BEING SENT: ${shopAmount} 🔥🔥🔥`);
      console.log(`Group.shopEarning value: ${group.shopEarning}`);
      console.log(`Is Special User: ${isSpecialUser}`);
      console.log(`Settings Code: ${group.printSettingsCode}`);
      console.log(`Full group object:`, JSON.stringify(group, null, 2));
      console.log(`🚨🚨🚨 END WEBAPP SEND 🚨🚨🚨\n`);
      
      // Call the addPrintJob function
       /* await addPrintJob({
        shop_id: selectedShop,
        group_id: group.id,
        copies: copies,
        pages: pages,
        amount: jobAmount,
        shop_amt: shopAmount,
        printsettings_code: group.printSettingsCode || 0,
        combined_file_path: updatedFiles[i]?.combined_file || '', 
        email_invoice_path: email_invoice_path,
        file_path: group.uploadFilePath,
        file_name: fileName,
        status: 'pending',
        source: group.source || 'default' // Use group's source
      }); */
      // Add to successful uploads
      result.successfulUploads.push({
        groupId: group.id,
        settingsCode: group.printSettingsCode || 0
      });
      
      result.totalUploaded++;
    } catch (error) {
      console.error(`Failed to upload print job for group ${group.id}:`, error);
      
      // Add to failed uploads
      result.failedUploads.push({
        groupId: group.id,
        error: error instanceof Error ? error.message : 'Unknown error'
      });
      
      // Set overall success to false if any upload fails
      result.success = false;
    }
  }
  
  console.log(`Print job upload complete: ${result.totalUploaded} successful, ${result.failedUploads.length} failed`);
  return result;
}

// Note: When creating database records, use group properties like:
// - group.totalPages for the number of pages
// - group.price for the price specific to this group
